module.exports = __webpack_public_path__ + "static/media/sleep-quality.e72e8b38.png";